import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const BlockUserNotifPageUI = ({context, messageList,
    onSubmit, submitted, successMsg, errorList, setErrorList, onCancel
  }) =>
  <PublicPageSF context={context} className='pg_blk_prj_eml' centered={!messageList}
    messageList={messageList} headerMessageKey='c_opt_out_email_q'>
    {
      !messageList &&
      <SpinnerComponentUI />
    }

    {
      messageList &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_opt_out_email_q' />
        <CardUI>
          <FormSF context={context} messageList={messageList}
              buttonMessageKey='c_opt_out' cancelMessageKey='c_cancel'
              onSubmit={onSubmit} onCancel={onCancel} busy={submitted}
              successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}>
            <MessageUI messageList={messageList} messageKey='c_opt_out_email_desc' />
          </FormSF>
        </CardUI>
      </React.Fragment>
    }
  </PublicPageSF>

export default BlockUserNotifPageUI
